module.exports = __webpack_public_path__ + "img/photos/slider-01a-mobile.jpg";